import {useTranslation} from 'react-i18next'
import {twJoin} from 'tailwind-merge'

import {IconClose} from '@sdox/icons'

import {Button} from '../../../Button'

import type {ReactNode} from 'react'

export interface HeaderProps {
  onClose: () => void
  heading?: ReactNode
}

export const TocHeader = ({heading, onClose}: HeaderProps) => {
  const {t} = useTranslation()
  return (
    <div
      className={twJoin(
        'flex items-center justify-between self-stretch',
        'py-spacing-8 pl-spacing-36 pr-spacing-12 md:py-spacing-16 md:pl-spacing-48',
      )}
    >
      {heading ? (
        <p
          id={'toc-title'}
          className={'text-p1'}
        >
          {heading}
        </p>
      ) : null}
      <Button
        role={'button'}
        variant={'flat'}
        size={'medium'}
        leading={<IconClose />}
        onClick={onClose}
        aria-label={t('common:close')}
      />
    </div>
  )
}
